import React, {useState} from 'react'
import {Button} from 'react-bootstrap'
import toast from 'react-hot-toast'
import ExcelJS from 'exceljs'

import {validateFleetDataForExport} from './validateData'
import {generateLoginstatusWorksheet} from './worksheetGenerator'
import {saveWorkbookAsExcel} from '../../../helpers/saveWorkbook'
import {autoSizeColumns} from '../../../helpers/autoSizeColumns'

interface ExportToExcelProps {
  data: Array<Record<string, any>>
  fileName?: string
  titleMap: Record<string, string>
  heading?: string
}

const ExportToExcelButton: React.FC<ExportToExcelProps> = ({
  data,
  fileName = 'ExportedData',
  titleMap,
  heading,
}) => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (!validateFleetDataForExport(data)) {
      toast.error('No data to export!')
      return
    }

    try {
      setIsExporting(true)
      const workbook = new ExcelJS.Workbook()
      const worksheet = generateLoginstatusWorksheet(workbook, data, titleMap, heading)

      autoSizeColumns(worksheet)

      await saveWorkbookAsExcel(workbook, fileName)
    } catch (err) {
      console.error('Export error:', err)
      toast.error('Failed to export data.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button onClick={handleExport} disabled={isExporting} size="sm">
      <div className="flex items-center gap-2">
        Download{' '}
        {isExporting ? (
          <i className="bi bi-arrow-repeat spinner-border spinner-border-sm me-1" />
        ) : (
          <i className="bi bi-download fs-5" />
        )}
      </div>
    </Button>
  )
}

export default ExportToExcelButton
